<template>
	<div class="navbar">
		<hamburger :is-active="sidebar.opened" class="hamburger-container" @toggleClick="toggleSideBar" />

		<breadcrumb class="breadcrumb-container" />

		<div class="right-menu">

			<el-button v-if="newMsg.hasNewMsg" title="有新的用户认证信息待处理" class="right-menu-item blink" type="msg"
				size="small" icon="el-icon-message" @click="go2Authentication"></el-button>

			<template v-if="device !== 'mobile'">
				<search id="header-search" class="right-menu-item" />
			</template>

			<el-dropdown class="avatar-container right-menu-item" trigger="click">
				<div class="avatar-wrapper">
					<div class="user-name row-dots">{{ name }}</div>
					<img :src=imageUrl class="user-avatar" />
					<i class="el-icon-caret-bottom" />
				</div>
				<el-dropdown-menu slot="dropdown" class="user-dropdown">
					<router-link to="/userSetting/accountSetting">
						<el-dropdown-item>
							{{ $t("route.accountSetting") }}
						</el-dropdown-item>
					</router-link>
<!--					<router-link to="/userSetting/feedback">-->
<!--						<el-dropdown-item>-->
<!--							{{ $t("route.feedback") }}-->
<!--						</el-dropdown-item>-->
<!--					</router-link>-->
					<el-dropdown-item divided @click.native="logout">
						<span style="display: block">{{ $t("login.logout") }}</span>
					</el-dropdown-item>
				</el-dropdown-menu>
			</el-dropdown>
		</div>
	</div>
</template>

<script>
	import {
		mapGetters
	} from "vuex";
	import Breadcrumb from "@/components/Breadcrumb";
	import Hamburger from "@/components/Hamburger";
	import Search from "@/components/HeaderSearch";
	import defaultImage from "/src/assets/images/defaultImage.jpeg";
	import config from "@/utils/config.js"

	export default {
		data() {
			return {
				imageUrl: defaultImage,
			};
		},
		components: {
			Breadcrumb,
			Hamburger,
			Search,
		},
		computed: {
			...mapGetters(["sidebar", "avatar", "name", "device", 'newMsg']),
		},
		created() {
			if (this.avatar !==null) {
				this.imageUrl = config.RESOURCES + this.avatar;
				console.log(config.RESOURCES + this.avatar);
			}
		},
		methods: {
			toggleSideBar() {
				this.$store.dispatch("app/toggleSideBar");
			},
			async logout() {
				await this.$store.dispatch("user/logout");
				this.$router.push(`/login?redirect=${this.$route.fullPath}`);
			},
			go2Authentication() {
				this.$router.push("/systemManagement");
			}
		},
	};
</script>

<style lang="scss" scoped>
	.navbar {
		height: 50px;
		overflow: hidden;
		position: relative;
		background: #fff;
		box-shadow: 0 1px 4px rgba(0, 21, 41, 0.08);

		.hamburger-container {
			line-height: 46px;
			height: 100%;
			float: left;
			cursor: pointer;
			transition: background 0.3s;
			-webkit-tap-highlight-color: transparent;

			&:hover {
				background: rgba(0, 0, 0, 0.025);
			}
		}

		.breadcrumb-container {
			float: left;
		}

		.right-menu {
			float: right;
			height: 100%;
			line-height: 50px;

			&:focus {
				outline: none;
			}

			.right-menu-item {
				display: inline-block;
				padding: 0 8px;
				height: 100%;
				font-size: 18px;
				color: #5a5e66;
				vertical-align: text-bottom;

				&.hover-effect {
					cursor: pointer;
					transition: background 0.3s;

					&:hover {
						background: rgba(0, 0, 0, 0.025);
					}
				}
			}

			.avatar-container {
				margin-right: 30px;

				.avatar-wrapper {
					margin-top: 5px;
					position: relative;
					display: flex;
					align-items: center;

					.user-name {
						cursor: pointer;
						max-width: 200px;
						height: 40px;
						line-height: 40px;
						font-size: 18px;
						padding-right: 15px;
					}

					.user-avatar {
						cursor: pointer;
						width: 40px;
						height: 40px;
						border-radius: 10px;
					}

					.el-icon-caret-bottom {
						cursor: pointer;
						position: absolute;
						right: -20px;
						top: 25px;
						font-size: 12px;
					}
				}
			}
		}
	}

	@keyframes blink {
		0% {
			opacity: 1;
		}

		50% {
			opacity: 1;
			transform: scale(1);
		}

		100% {
			opacity: 0;
			transform: scale(0.5);
		}
	}

	.blink {
		animation: blink 1s infinite;
	}

	.el-button--msg {
		background-color: transparent;
		border-color: transparent;
	}
</style>
